export default "__VITE_ASSET__vOtLTBhJ__"